import React from 'react'
import PropTypes from 'prop-types'

import { ReorderBanner } from '../ReorderBanner/ReorderBanner'
import { ReorderBannerPasswordless } from '../ReorderBanner/ReorderBannerPasswordless'
import { PopularItems } from '../PopularItems/PopularItems'
import { useAuth } from '../AuthProvider/AuthProvider'
import { useIsPasswordlessAuthEnabled } from '@local/do-secundo-passwordless-authentication'

const ReordersOrPopularItemsBanner = ({ hasReorders = false }) => {
  const { authenticated } = useAuth()
  const canReorder = hasReorders && authenticated
  const PASSWORDLESS_ENABLED = useIsPasswordlessAuthEnabled()

  if (canReorder) {
    return PASSWORDLESS_ENABLED ? (
      <ReorderBannerPasswordless />
    ) : (
      <ReorderBanner />
    )
  }

  return <PopularItems />
}

ReordersOrPopularItemsBanner.propTypes = {
  hasReorders: PropTypes.bool.isRequired
}

export { ReordersOrPopularItemsBanner }
